import React from 'react';
import { dayNumPadded, weekdayShort, monthShort, year } from '../../utils/dates';

// Reusable date "part": a vertical stack — weekday over the big day number over
// month+year. Self-contained (.ec-date), so it works in any card layout
// (agenda-row, featured, ...).
const EventDate = ({ date }) => (
    <div className="ec-date">
        <span>{weekdayShort(date)}</span>
        <strong>{dayNumPadded(date)}</strong>
        <span>{monthShort(date)} {year(date)}</span>
    </div>
);

export default EventDate;
